import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=f6356f60&scoped=true"
import script from "./Legal.vue?vue&type=script&lang=js"
export * from "./Legal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6356f60",
  null
  
)

export default component.exports